import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import queryString from 'query-string'

const params = queryString.parse(location.search);
window.app = params.app === "1";
window.track = params.track;
window.PRODUCTION = PRODUCTION;

if (!app) {
    window.editAnswers = false;
} else {
    initCookiebotTracking();
    window.editResultDate = params.resultDate;
    window.editDate = params.date;
    window.editIgnoreHolidays = parse(params.ignoreHolidays);
    window.editResultInfo = params.resultInfo;

    window.editAnswers = parse(params.answers);
    window.editPrintDate = params.printDate;
    window.editResultDate2 = params.resultDate2;
    window.editDate2 = params.date2;
}

function parse(string) {
    return string ? JSON.parse(string) : false;
}

function initCookiebotTracking(){
    if (window.app) {
        if (window.track === "0") {
            Cookiebot.submitCustomConsent(false, false, false);
            Cookiebot.hide();
        } else if (window.track === "1"){
            Cookiebot.submitCustomConsent(true, true, true);
            Cookiebot.hide();
        } 
    }
}
window.sendObjectMessage = function (url) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    document.documentElement.appendChild(iframe);
    iframe.parentNode.removeChild(iframe);
    iframe = null;
};

ReactDOM.render(<App isApp={app} />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js